import { api } from './client'

export const listUsers = () => api.get('/users').then((r) => r.data)
export const lookupUserByEmail = (email) => api.get('/users/lookup', { params: { email } }).then((r) => r.data)
export const createUser = (data) => api.post('/users', data).then((r) => r.data)
export const updateUser = (id, data) => api.put(`/users/${id}`, data).then((r) => r.data)
export const deleteUser = (id) => api.delete(`/users/${id}`).then((r) => r.data)

// Hak pemilik data. Ekspor = berkas JSON seluruh data pribadi satu orang;
// penghapusan = anonimisasi (nilai dan kehadiran tetap, identitas hilang) dan
// tidak bisa dibatalkan, sehingga server menuntut `confirm` = email akunnya.
export const exportUserData = (id) =>
  api.get(id === 'me' ? '/users/me/data-export' : `/users/${id}/data-export`, { responseType: 'blob' }).then((r) => {
    const m = /filename="?([^";]+)"?/i.exec(r.headers?.['content-disposition'] || '')
    return { blob: r.data, filename: m ? decodeURIComponent(m[1]) : 'data-pribadi.json' }
  })
export const eraseUserData = (id, confirm, reason) =>
  api.post(`/users/${id}/erase`, { confirm, ...(reason ? { reason } : {}) }).then((r) => r.data)
// Sertifikat Nautika/Hubla satu peserta — jalur koreksi di luar re-import CSV massal.
export const getMaritimeCert = (userId) => api.get(`/users/${userId}/maritime-cert`).then((r) => r.data)
export const updateMaritimeCert = (userId, data) => api.patch(`/users/${userId}/maritime-cert`, data).then((r) => r.data)
// ?class_id= untuk semua laporan: kosong = seluruh program, terisi = satu kelas.
const kelasParam = (classId) => (classId ? { class_id: classId } : {})
// `saringan` (opsional) = hasil keQuery() di lib/reportFilters.js. Pemanggil
// berargumen lama tetap mengirim permintaan yang sama persis seperti sebelumnya.
const params = (classId, saringan) => ({ ...kelasParam(classId), ...(saringan || {}) })
export const programProgress = (pid, classId, saringan) =>
  api.get(`/reports/programs/${pid}/progress`, { params: params(classId, saringan) }).then((r) => r.data)
// classId opsional: tanpanya angka seluruh program, dengannya angka satu
// angkatan saja. Pemanggil berargumen-tunggal tetap mengirim permintaan yang
// sama persis seperti sebelumnya.
export const programAnalytics = (pid, classId) =>
  api
    .get(`/reports/programs/${pid}/analytics`, {
      params: classId ? { class_id: classId } : undefined,
    })
    .then((r) => r.data)
export const programCoursesProgress = (pid, classId, saringan) =>
  api.get(`/reports/programs/${pid}/courses-progress`, { params: params(classId, saringan) }).then((r) => r.data)
export const analyticsOverview = (range) =>
  api.get('/reports/analytics/overview', { params: { range } }).then((r) => r.data)
// Snapshot se-lembaga: peserta/tersertifikasi/pending dihitung per ORANG
// lintas program, jadi satu orang di dua program tetap satu. Tanpa rentang
// waktu — ini keadaan sekarang, bukan tren.
export const analyticsSummary = () =>
  api.get('/reports/analytics/summary').then((r) => r.data)
export const downloadProgressCsv = (pid, classId, saringan) =>
  api.get(`/reports/programs/${pid}/progress.csv`, { params: params(classId, saringan), responseType: 'blob' }).then((r) => r.data)
export const downloadImoCsv = (pid) =>
  api.get(`/reports/programs/${pid}/imo.csv`, { responseType: 'blob' }).then((r) => r.data)
// FR-23: enriched IMO/Hubla compliance report (classId opsional, scope ke satu angkatan)
export const downloadImoComplianceCsv = (pid, classId, saringan) =>
  api.get(`/reports/programs/${pid}/imo-compliance.csv`, { params: params(classId, saringan), responseType: 'blob' }).then((r) => r.data)
export const downloadImoCompliancePdf = (pid, classId, saringan) =>
  api.get(`/reports/programs/${pid}/imo-compliance.pdf`, { params: params(classId, saringan), responseType: 'blob' }).then((r) => r.data)
export const downloadProgressPdf = (pid, classId, saringan) =>
  api.get(`/reports/programs/${pid}/progress.pdf`, { params: params(classId, saringan), responseType: 'blob' }).then((r) => r.data)
export const downloadProgressXlsx = (pid, classId, saringan) =>
  api.get(`/reports/programs/${pid}/progress.xlsx`, { params: params(classId, saringan), responseType: 'blob' }).then((r) => r.data)
export const downloadCoursesProgressCsv = (pid, classId, saringan) =>
  api.get(`/reports/programs/${pid}/courses-progress.csv`, { params: params(classId, saringan), responseType: 'blob' }).then((r) => r.data)
export const downloadCoursesProgressPdf = (pid, classId, saringan) =>
  api.get(`/reports/programs/${pid}/courses-progress.pdf`, { params: params(classId, saringan), responseType: 'blob' }).then((r) => r.data)
export const downloadCoursesProgressXlsx = (pid, classId, saringan) =>
  api.get(`/reports/programs/${pid}/courses-progress.xlsx`, { params: params(classId, saringan), responseType: 'blob' }).then((r) => r.data)
// Learning Gain (FR-7.5), classId opsional — sama seperti getCohortLearningGain di tests.api.js
export const downloadLearningGainXlsx = (pid, classId) =>
  api.get(`/reports/programs/${pid}/learning-gain.xlsx`, { params: classId ? { class_id: classId } : {}, responseType: 'blob' }).then((r) => r.data)
export const downloadLearningGainPdf = (pid, classId) =>
  api.get(`/reports/programs/${pid}/learning-gain.pdf`, { params: classId ? { class_id: classId } : {}, responseType: 'blob' }).then((r) => r.data)
export const programAttendance = (pid, classId, saringan) =>
  api.get(`/reports/programs/${pid}/attendance`, { params: params(classId, saringan) }).then((r) => r.data)
export const downloadAttendanceCsv = (pid, classId, saringan) =>
  api.get(`/reports/programs/${pid}/attendance.csv`, { params: params(classId, saringan), responseType: 'blob' }).then((r) => r.data)
export const downloadAttendancePdf = (pid, classId, saringan) =>
  api.get(`/reports/programs/${pid}/attendance.pdf`, { params: params(classId, saringan), responseType: 'blob' }).then((r) => r.data)
export const downloadAttendanceXlsx = (pid, classId, saringan) =>
  api.get(`/reports/programs/${pid}/attendance.xlsx`, { params: params(classId, saringan), responseType: 'blob' }).then((r) => r.data)
export const downloadImoComplianceXlsx = (pid, classId, saringan) =>
  api.get(`/reports/programs/${pid}/imo-compliance.xlsx`, { params: params(classId, saringan), responseType: 'blob' }).then((r) => r.data)
// Satu baris per pemindaian — siapa hadir di sesi mana, dengan perusahaannya.
// Unduhan di atas hanya merekap jumlah per sesi, tanpa satu nama pun.
export const downloadAttendanceDetailCsv = (pid, classId, saringan) =>
  api.get(`/reports/programs/${pid}/attendance-detail.csv`, { params: params(classId, saringan), responseType: 'blob' }).then((r) => r.data)
export const downloadAttendanceDetailXlsx = (pid, classId, saringan) =>
  api.get(`/reports/programs/${pid}/attendance-detail.xlsx`, { params: params(classId, saringan), responseType: 'blob' }).then((r) => r.data)
export const downloadAttendanceDetailPdf = (pid, classId, saringan) =>
  api.get(`/reports/programs/${pid}/attendance-detail.pdf`, { params: params(classId, saringan), responseType: 'blob' }).then((r) => r.data)
// Satu kolom per soal, berisi jawaban tiap peserta beserta penanda benar/salah.
// Laporan lain merekap angka; yang ini merekam apa yang sebenarnya dijawab.
// kind: 'pretest' | 'posttest'
//
// Excel, bukan CSV: CSV di repo ini dipisah koma, sedangkan Excel berbahasa
// Indonesia mengharapkan titik koma — semua data menumpuk di satu kolom.
export const downloadTestAnswersXlsx = (pid, kind, classId, saringan) =>
  api
    .get(`/reports/programs/${pid}/test-answers.xlsx`, { params: { kind, ...params(classId, saringan) }, responseType: 'blob' })
    .then((r) => r.data)
// Versi CSV dibiarkan ada: tab yang terbuka sebelum deploy masih memanggilnya.
export const downloadTestAnswersCsv = (pid, kind, classId, saringan) =>
  api
    .get(`/reports/programs/${pid}/test-answers.csv`, { params: { kind, ...params(classId, saringan) }, responseType: 'blob' })
    .then((r) => r.data)
// Laporan akhir pelatihan untuk perusahaan klien. Tanpa `company` berarti
// seluruh kelas, dikelompokkan per perusahaan.
export const downloadClientReportPdf = (pid, company, classId) =>
  api
    .get(`/reports/programs/${pid}/client-report.pdf`, {
      params: { ...(company ? { company } : {}), ...kelasParam(classId) },
      responseType: 'blob',
    })
    .then((r) => r.data)
export const downloadClientReportCsv = (pid, company, classId) =>
  api
    .get(`/reports/programs/${pid}/client-report.csv`, {
      params: { ...(company ? { company } : {}), ...kelasParam(classId) },
      responseType: 'blob',
    })
    .then((r) => r.data)
export const downloadClientReportXlsx = (pid, company, classId) =>
  api
    .get(`/reports/programs/${pid}/client-report.xlsx`, {
      params: { ...(company ? { company } : {}), ...kelasParam(classId) },
      responseType: 'blob',
    })
    .then((r) => r.data)
// Rekap Kehadiran — satu baris per PESERTA, satu kolom per sesi. Dua unduhan
// kehadiran di atas menjawab pertanyaan lain: yang satu merekap per sesi tanpa
// nama, yang satu memanjang satu baris per pemindaian. Yang ini satu-satunya
// yang terbaca sekilas untuk memutuskan sertifikat.
export const downloadAttendanceMatrixCsv = (pid, classId) =>
  api.get(`/reports/programs/${pid}/attendance-matrix.csv`, { params: kelasParam(classId), responseType: 'blob' }).then((r) => r.data)
export const downloadAttendanceMatrixXlsx = (pid, classId) =>
  api.get(`/reports/programs/${pid}/attendance-matrix.xlsx`, { params: kelasParam(classId), responseType: 'blob' }).then((r) => r.data)
export const downloadAttendanceMatrixPdf = (pid, classId) =>
  api.get(`/reports/programs/${pid}/attendance-matrix.pdf`, { params: kelasParam(classId), responseType: 'blob' }).then((r) => r.data)
